var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout layout--form",attrs:{"id":"app"}},[_c('announcements-bar'),_c('static-header-bar'),_c('div',{staticClass:"page-form with-cover"},[_c('div',{staticClass:"cover"}),_c('div',{staticClass:"content"},[_c('nuxt')],1)]),_c('cookie-consent-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }